import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ScreenHelpRoutingModule } from '@kp/screen-help/screen-help-routing.module';
import { SharedModule } from '@kp/shared/shared.module';

@NgModule({
  declarations: [ScreenHelpRoutingModule.components],
  imports: [CommonModule, ScreenHelpRoutingModule, SharedModule],
})
export class ScreenHelpModule {}
